import type { PropsWithChildren } from 'react'
import React from 'react'
import { ThemeProvider } from '@mui/material'
import theme from 'redesign/themes/main'

const RedesignThemeWrapper: React.FC<PropsWithChildren> = ({ children }) => (
  <ThemeProvider theme={theme}>{children}</ThemeProvider>
)

export default RedesignThemeWrapper
